import { render, staticRenderFns } from "./ShareLink.vue?vue&type=template&id=a94d6504"
import script from "./ShareLink.vue?vue&type=script&lang=ts"
export * from "./ShareLink.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports